import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { Button, Sheet } from "@tc/ui";
/**
 * "Are you sure?" as a sheet, like every other confirm in Nozl, instead of the browser's own box (unstyled, blocks the
 * page, and can't be read out properly). `confirm(title, run)` opens it; render `sheet` once on the page.
 */
export function useConfirm() {
    const [ask, setAsk] = useState(null);
    const confirm = (title, run, opts = {}) => setAsk({ title, run, yes: opts.yes ?? "Yes", text: opts.text });
    const sheet = (_jsx(Sheet, { open: ask !== null, onClose: () => setAsk(null), title: ask?.title ?? "", foot: _jsxs("div", { className: "tc-form-row", children: [_jsx(Button, { primary: true, onClick: () => { const run = ask?.run; setAsk(null); run?.(); }, children: ask?.yes ?? "Yes" }), _jsx(Button, { onClick: () => setAsk(null), children: "Cancel" })] }), children: ask?.text ? _jsx("p", { className: "tc-m0", children: ask.text }) : null }));
    return { confirm, sheet };
}
